var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1822 10.5003H10.4997H14.1822Z",
    fill: "#0077CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 1.3336V5.50027H1.81801M1.81801 5.50027C2.37122 4.13204 3.36274 2.98602 4.6372 2.24182C5.91165 1.49761 7.39701 1.19728 8.86048 1.38788C10.324 1.57849 11.6828 2.24926 12.7241 3.29508C13.7655 4.3409 14.4304 5.70265 14.6147 7.16693M1.81801 5.50027H5.49967M14.6663 14.6669V10.5003H14.1822M14.1822 10.5003C13.6282 11.8677 12.6364 13.0128 11.362 13.7563C10.0877 14.4999 8.60279 14.7999 7.13976 14.6093C5.67673 14.4188 4.31817 13.7485 3.27679 12.7034C2.2354 11.6582 1.56997 10.2973 1.38467 8.8336M14.1822 10.5003H10.4997",
    stroke: "#0077CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.dc5de77b5bdbb0d4b721359615e728f4.svg";
export { ForwardRef as ReactComponent };